module.exports = __webpack_public_path__ + "img/background-7.8e15ee79.png";